import { useState } from "react";
import { useTranslation } from "react-i18next";

const PackItem = ({
    itemData
}) => {
    const { t } = useTranslation();
    const [date, setDate] = useState(() => {
        const formattedDateTime = new Date(itemData.created_at).toLocaleString();
        return formattedDateTime;
    })

    return (
        <div className="grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 bg-white rounded-lg p-2 dark:bg-slate-700">
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_user")}:</p>
                    <p className="text-gray-500 text-[14px]">
                        {(itemData.user !== null) && itemData.user.fname} {(itemData.user !== null) && itemData.user.lname} - {(itemData.user !== null) && itemData.user.id}
                    </p>
                </div>
            </div>
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_package_number")}</p>
                    <p className="text-gray-500 text-[14px]">{itemData.pack_id}</p>
                </div>
            </div>
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_date")}:</p>
                    <p className="text-gray-500 text-[14px]">{date}</p>
                </div>
            </div>
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_action")}</p>
                    <p className="text-gray-500 text-[14px]">{itemData.action}</p>
                </div>
            </div>
            <div className="w-full">

                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_description")}</p>
                    <p className="text-gray-500 text-[14px]">{itemData.description}</p>
                </div>
            </div>
        </div>
    )
}

export default PackItem;
